import { __assign } from "tslib";
import { getArgumentValues } from '@graphql-tools/utils';
import TransformObjectFields from './TransformObjectFields';
var FilterObjectFieldDirectives = /** @class */ (function () {
    function FilterObjectFieldDirectives(filter) {
        this.filter = filter;
    }
    FilterObjectFieldDirectives.prototype.transformSchema = function (originalWrappingSchema, subschemaConfig, transformedSchema) {
        var _this = this;
        var transformer = new TransformObjectFields(function (_typeName, _fieldName, fieldConfig) {
            var keepDirectives = fieldConfig.astNode.directives.filter(function (dir) {
                var directiveDef = originalWrappingSchema.getDirective(dir.name.value);
                var directiveValue = directiveDef ? getArgumentValues(directiveDef, dir) : undefined;
                return _this.filter(dir.name.value, directiveValue);
            });
            if (keepDirectives.length !== fieldConfig.astNode.directives.length) {
                fieldConfig = __assign(__assign({}, fieldConfig), { astNode: __assign(__assign({}, fieldConfig.astNode), { directives: keepDirectives }) });
                return fieldConfig;
            }
        });
        return transformer.transformSchema(originalWrappingSchema, subschemaConfig, transformedSchema);
    };
    return FilterObjectFieldDirectives;
}());
export default FilterObjectFieldDirectives;
//# sourceMappingURL=FilterObjectFieldDirectives.js.map